import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@environment';

@Component({
  selector: 'app-root',
  template: '<theme-root *ngIf="show" [buildNumber]="buildNumber"></theme-root>'
})
export class AppComponent implements OnInit {
    show: boolean = false;

    buildNumber: string = environment.buildNumber;

    constructor(private msal: MsalService) {
    }

    ngOnInit(): void {
        this.msal.handleRedirectObservable().subscribe(result => {
            console.log('redirect result: ' + result);
            this.show = true;
        });
    }
}
